/**
 * Application configuration
 */

// Determine the environment
const isDevelopment = process.env.NODE_ENV !== 'production';
const isStaging = process.env.REACT_APP_ENV === 'staging';

// Environment-specific API URLs
const getApiBaseUrl = () => {
  if (isDevelopment) {
    return 'http://localhost:5000';
  }
  // Staging/production: use relative paths — the SWA linked backend routes /api/*
  return '';
};

// Direct App Service origin for long-running calls that must bypass the SWA
// proxy: the SWA gateway kills requests after ~45s, while søknad generation
// legitimately takes ~90s. Only calls passing `directBackend: true` to
// authFetch use this — every other request stays on the relative SWA path
// above. In development this resolves to the same localhost backend.
// No hardcoded fallback: each deployed environment must set
// REACT_APP_DIRECT_API_URL at build time; authFetch throws if a caller
// requests the direct backend without it. (Backend CORS must allow the
// frontend origin — cfg.frontendOrigin in coord-backend/src/server.js.)
const getDirectApiBaseUrl = () => {
  if (isDevelopment) {
    return 'http://localhost:5000';
  }
  return process.env.REACT_APP_DIRECT_API_URL || null;
};

const config = {
  // API configuration
  api: {
    baseUrl: getApiBaseUrl(),
    directBaseUrl: getDirectApiBaseUrl(),
    endpoints: {
      conversations: '/api/conversations',
      collections: '/api/collections',
      profile: '/api/profile'
    }
  },

  // Authentication configuration
  auth: {
    // These should match your Azure AD B2C configuration
    scopes: ['openid'],
    requiresAuth: true,
    // Development mode settings
    development: {
      useDefaultUser: isDevelopment,
      defaultUserId: 'test-user-id'
    }
  },

  // Environment info
  environment: isDevelopment ? 'development' : isStaging ? 'staging' : 'production'
};

export default config;
